import { padStart } from "lodash";
import type { Cue } from "webvtt-parser";

const padNumber = (num: number) => padStart(num.toString(), 2, "0");

export const parseCueTime = (strTime: string) => {
  const numTime = Number(strTime);
  const hours = Math.floor(numTime / 3600);
  const minutes = Math.floor((numTime - hours * 3600) / 60);
  const seconds = Math.floor(numTime - hours * 3600 - minutes * 60);
  if (hours) {
    return `${padNumber(hours)}:${padNumber(minutes)}:${padNumber(seconds)}`;
  }
  return `${padNumber(minutes)}:${padNumber(seconds)}`;
};

export const isCurrentCue = (cue: Cue, currentTime: number) => {
  if (!cue) return false;
  const { startTime, endTime } = cue;
  return currentTime >= startTime && currentTime < endTime;
};
